// New Component - srini - 21/11/24
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './dialogBoxStyles'
import handleStartCall from '../../helpers/handleStartCall'

const DialogBox = ({ classes, open, handleClose, customerNumber, dispatch }) => {
    
    return (
        <>
            <Dialog
                open={open} onClose={handleClose}
                BackdropProps={{
                    style: {
                        backgroundColor: 'rgba(0,0,0,0)'
                    }
                }}
                PaperProps={{
                    className: classes.dialogPaper
                }}
            >
                <DialogTitle>
                    <Typography className={classes.cnfCllTxt}>
                        Confirm Call
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography className={classes.ayswtCllTxt}>Are you sure you want to call - {customerNumber} ?</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className={classes.cnclBtn}>
                        Cancel
                    </Button>
                    <Button
                        className={classes.cnfBtn}
                        onClick={() => {
                            handleStartCall(customerNumber, dispatch)
                            handleClose()
                        }}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog> 
        </>
    )
}

export default withStyles(styles)(DialogBox)